export enum DateFormat {
  FullDateWithTimeZone = 'YYYY/MM/DD hh:mm A [GMT]Z',
  MSWithLabel = 'mm[m] ss[s]',
  SWithLabel = 'ss[s]',
  YyyyMmDdHhMm = 'YYYY-MM-DD HH:mm',
  DdMmmHhMm = 'DD MMM, HH:mm',
}
